import React, { useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';

import PageWrapper from '../components/PageWrapper';
import camLoeppky from '../../assets/images/camLoeppky.png';
import ScrollToTop from '../components/ScrollToTop';


const MessageFromChairman = (props) => {
  const { height, width, MAX_WIDTH, isMobile } = props;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <PageWrapper height={height} showHeaderLogo maxWidth={MAX_WIDTH} isMobile={isMobile}>
      <Row style={{ marginTop: 120 }}>
        <Col>
          <Row>
            {!isMobile && width >= 576 && <Member />}
            <Col xs={12} sm={7} md={8} lg={9} xl={9}>
              <Row>
                {!isMobile && width < 576 && <Member />}
                <Col xs={7} sm={12}>
                  <h2
                    style={{ textAlign: 'left' }}
                    id="message-from-the-president"
                    tabIndex="-1"
                  >
                    {width < 576 ? 'mess-\n age' : 'message'} from {width < 576 ? 'CHAIR-\nMAN' : 'CHAIRMAN'}  of the board
                  </h2>
                </Col>

              </Row>

              <div className="quoteSubheader" style={{ marginTop: 30 }}>
                As CSIO reached the final year of its multi-year
                strategic roadmap, I look back on everything we’ve
                accomplished together since 2018 with a strong
                sense of pride. Milestones such as launching My
                Proof of Insurance (MPOI), forming the Commercial
                Lines (CL) Working Group and establishing the
                Innovation and Emerging Technology (INNOTECH)
                Advisory Committee have positioned us for
                sustained future success. Even as the P&C insurance
                industry rapidly evolves, I’m confident CSIO’s
                leading-edge technology Standards and solutions
                will continue to enhance customer experiences in
                the broker channel.
              </div>
              <p style={{ marginTop: 30 }}>                
                Customers and brokers are already benefiting from the outstanding efforts of the INNOTECH Advisory Committee and its Working Groups to advance digital solutions and facilitate more access to data. By successfully leveraging the CSIOnet and CSIO eDocs Standards, they expanded the scope of eDocs with Billing and Claims eDocs notifications. This practical and effective solution allows for up-to-date claims status and billing information—a 
                giant step forward in the insurer-broker partnership. The API Working Group finalized JSON API Standards for personal and commercial insurance policy inquiry, allowing larger volumes of information to move between insurer and broker systems in real-time. This was the first industry standard using JSON for APIs.
                <br /><br />
                Industry-wide adoption of CL Data Standards remained a key priority. The CL Working Group made exceptional strides by defining requirements for multi-operations small business quote and bind. CSIO’s CL Certification Program played an important role in promoting market-ready CL Data Standards segments.
                <br /><br />
                CSIO also contributed to the digitization of member operations by continuously enhancing My Proof of Insurance and supporting brokers and insurers in implementing the solution. Over the last couple of years, hundreds of thousands of customers across Canada securely received electronic proof of auto insurance (eSlips), and other digital policy documents, through My Proof of Insurance which is a testament of the value that this solution brings.
                <br /><br />
                All these accomplishments are the well-earned result of insurer, broker and vendor members coming together on Committees and Working Groups for the betterment of the industry. Their collective passion, innovative spirit and dedication made the vision outlined in our strategic plan a reality.
                <br /><br />
                As Chairman of the Board, I have had the privilege of working closely with amazing colleagues on the Board of Directors, it has been the most rewarding part of the journey. I look forward to seeing how all the talented individuals who contribute to CSIO’s success continue raising the bar for Standards, solutions and technology in the P&C
                broker channel.
                <br /><br />Sincerely,<br /><br />Cam Loeppky, CSIO Chairman<br />The Wawanesa Mutual Insurance Company<br />Senior Vice President & Chief Information Officer          </p>
            </Col>
          </Row>
        </Col>
      </Row>
      <ScrollToTop height={height} width={width} maxWidth={MAX_WIDTH} />
    </PageWrapper>
  )
}

export default MessageFromChairman;

const Member = () => (
  <Col xs={5} sm={5} md={4} lg={3} xl={3} style={{
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  }}>
    <img
      src={camLoeppky}
      style={{
        width: '100%',
        height: 'auto',
        marginLeft: 40,
        marginRight: 40,
        // marginTop: 60
        marginTop: 8,
        marginBottom: 25
      }}
      aria-label="Picture of Cam Loeppky"
    />
    <div className="homepageExecName">
      CAM LOEPPKY
    </div>
    <div className="homepageExecTitle">
      CSIO CHAIRMAN
    </div>
    <div className="homepageExecDetail" style={{ paddingLeft: 8, paddingRight: 8 }}>
      The Wawanesa Mutual <br />Insurance Company<br />Senior Vice President &<br/> Chief Information Officer
    </div>
  </Col>
);
